<template>
    <span class="currency">
        <Spinner v-if="loading" />
        <template v-else>{{ amountFormatted }}</template>
    </span>
</template>

<script>
    import Spinner from '../Spinner'

    export default {
        name: 'Currency',
        components: {
            Spinner
        },
        props: {
            amount: {
                type: Number,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            formatPositiveNumber: {
                type: Boolean,
                default: false
            },
            displaySign: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            amountFormatted() {
                return new Intl.NumberFormat(this.$i18n.locale, {
                    style: 'currency',
                    currency: 'EUR',
                    signDisplay: this.signDisplay
                }).format(this.amount)
            },
            signDisplay() {
                return (this.formatPositiveNumber ? 'exceptZero' : (this.displaySign ? 'always' : undefined));
            }
        }
    }
</script>
